import { Helmet } from 'react-helmet';

import { FailuresTable } from '../../components/Tables/Sigma/FailuresTable';

const FailuresPage = () => {
  return (
    <div className='table-module-container'>
      {/* Helmet sets the HTML <title> dynamically */}
      <Helmet>
        <title>Regions</title>
      </Helmet>
      <div className='datatable'>
        {/* Render the RegionsTable component */}
        <FailuresTable />
      </div>
    </div>
  );
};

export default FailuresPage;
